import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * API-key management moved to `/developer/access` ("MCP & API config", #642)
 * — Sending no longer owns it, so this path redirects rather than rendering
 * its own copy (no key management on two pages).
 */
export const Route = createFileRoute(
  "/dashboard/w/$workspaceId/sending/api-keys",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/developer/access",
      params: { workspaceId: params.workspaceId },
    });
  },
});
